var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbsentPresentReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.77538,
    y: 15.75,
    width: 20.25,
    height: 10.5,
    rx: 4,
    fill: "#FFE5D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2754,
    y: 15.75,
    width: 20.25,
    height: 10.5,
    rx: 4,
    fill: "#FFE5D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.77538,
    y: 47.25,
    width: 20.25,
    height: 10.5,
    rx: 4,
    fill: "#FFE5D0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2754,
    y: 47.25,
    width: 20.25,
    height: 10.5,
    rx: 4,
    fill: "#FFE5D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9004,
    cy: 7.87512,
    r: 6.375,
    fill: "#FFE5D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4004,
    cy: 7.87512,
    r: 6.375,
    fill: "#FFE5D0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9004,
    cy: 39.375,
    r: 6.375,
    fill: "#FFE5D0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4004,
    cy: 39.375,
    r: 6.375,
    fill: "#FFE5D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2627 45.7627C18.186 45.7627 21.3813 42.5673 21.3813 38.644C21.3813 34.7208 18.186 31.5254 14.2627 31.5254C10.3394 31.5254 7.14406 34.7208 7.14406 38.644C7.14406 42.5673 10.3394 45.7627 14.2627 45.7627ZM14.2627 34.0052C16.8289 34.0052 18.9139 36.0902 18.9139 38.6564C18.9139 41.2225 16.8289 43.3075 14.2627 43.3075C11.6965 43.3075 9.61153 41.2225 9.61153 38.6564C9.61153 36.0902 11.7089 34.0052 14.2627 34.0052Z",
    fill: "#FD7E14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7373 45.7627C46.6606 45.7627 49.8559 42.5673 49.8559 38.644C49.8559 34.7208 46.6606 31.5254 42.7373 31.5254C38.814 31.5254 35.6186 34.7208 35.6186 38.644C35.6186 42.5673 38.814 45.7627 42.7373 45.7627ZM42.7373 34.0052C45.3034 34.0052 47.3885 36.0902 47.3885 38.6564C47.3885 41.2225 45.3034 43.3075 42.7373 43.3075C40.1711 43.3075 38.0861 41.2225 38.0861 38.6564C38.0861 36.0902 40.1711 34.0052 42.7373 34.0052Z",
    fill: "#FD7E14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14406 7.11864C7.14406 11.0419 10.3394 14.2373 14.2627 14.2373C18.186 14.2373 21.3813 11.0419 21.3813 7.11864C21.3813 3.19537 18.186 0 14.2627 0C10.3394 0 7.14406 3.19537 7.14406 7.11864ZM18.9015 7.11864C18.9015 9.68481 16.8165 11.7698 14.2504 11.7698C11.6842 11.7698 9.59919 9.68481 9.59919 7.11864C9.59919 4.55248 11.6965 2.46747 14.2504 2.46747C16.8042 2.46747 18.9015 4.55248 18.9015 7.11864Z",
    fill: "#FD7E14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7373 0C38.814 0 35.6186 3.19537 35.6186 7.11864C35.6186 11.0419 38.814 14.2373 42.7373 14.2373C46.6606 14.2373 49.8559 11.0419 49.8559 7.11864C49.8436 3.19537 46.6606 0 42.7373 0ZM42.7373 11.7698C40.1711 11.7698 38.0861 9.68481 38.0861 7.11864C38.0861 4.55248 40.1711 2.46747 42.7373 2.46747C45.3034 2.46747 47.3885 4.55248 47.3885 7.11864C47.3885 9.68481 45.2911 11.7698 42.7373 11.7698Z",
    fill: "#FD7E14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7721 25.2103H53.4153V20.6143C53.4153 17.659 50.842 15.2543 47.6795 15.2543H37.4705C34.3079 15.2543 31.7347 17.659 31.7347 20.6143V25.2103H25.2653V20.6143C25.2653 17.659 22.6921 15.2543 19.5295 15.2543H9.32054C6.15804 15.2543 3.58474 17.659 3.58474 20.6143V25.2103H1.22789C0.566534 25.2103 0.0254211 25.7159 0.0254211 26.334C0.0254211 26.952 0.566534 27.4577 1.22789 27.4577H4.78722H24.0629H32.9371H52.2128H55.7721C56.4335 27.4577 56.9746 26.952 56.9746 26.334C56.9746 25.7159 56.4335 25.2103 55.7721 25.2103ZM20.1669 25.2103V23.1539C20.1669 22.5359 19.6257 22.0302 18.9644 22.0302C18.303 22.0302 17.7619 22.5359 17.7619 23.1539V25.2103H9.88571V23.1539C9.88571 22.5359 9.34459 22.0302 8.68323 22.0302C8.02187 22.0302 7.48076 22.5359 7.48076 23.1539V25.2103H5.97767V20.6143C5.97767 18.8951 7.46873 17.5017 9.30852 17.5017H19.5175C21.3573 17.5017 22.8484 18.8951 22.8484 20.6143V25.2103H20.1669ZM48.918 25.2103V23.1539C48.918 22.5359 48.3769 22.0302 47.7155 22.0302C47.0542 22.0302 46.5131 22.5359 46.5131 23.1539V25.2103H38.6369V23.1539C38.6369 22.5359 38.0957 22.0302 37.4344 22.0302C36.773 22.0302 36.2319 22.5359 36.2319 23.1539V25.2103H34.1396V20.6143C34.1396 18.8951 35.6307 17.5017 37.4705 17.5017H47.6795C49.5192 17.5017 51.0103 18.8951 51.0103 20.6143V25.2103H48.918Z",
    fill: "#FD7E14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7721 57.5652H53.4153V52.5863C53.4153 49.3847 50.842 46.7795 47.6795 46.7795H37.4705C34.3079 46.7795 31.7346 49.3847 31.7346 52.5863V57.5652H25.2653V52.5863C25.2653 49.3847 22.6921 46.7795 19.5295 46.7795H9.32054C6.15804 46.7795 3.58474 49.3847 3.58474 52.5863V57.5652H1.22789C0.566534 57.5652 0.0254211 58.113 0.0254211 58.7825C0.0254211 59.4521 0.566534 59.9999 1.22789 59.9999H4.78722H24.0629H32.9371H52.2128H55.7721C56.4335 59.9999 56.9746 59.4521 56.9746 58.7825C56.9746 58.113 56.4335 57.5652 55.7721 57.5652ZM20.1669 57.5652V55.3375C20.1669 54.6679 19.6257 54.1201 18.9644 54.1201C18.303 54.1201 17.7619 54.6679 17.7619 55.3375V57.5652H9.88571V55.3375C9.88571 54.6679 9.34459 54.1201 8.68323 54.1201C8.02187 54.1201 7.48076 54.6679 7.48076 55.3375V57.5652H5.97767V52.5863C5.97767 50.7237 7.46873 49.2142 9.30852 49.2142H19.5175C21.3573 49.2142 22.8484 50.7237 22.8484 52.5863V57.5652H20.1669ZM48.918 57.5652V55.3375C48.918 54.6679 48.3769 54.1201 47.7155 54.1201C47.0542 54.1201 46.5131 54.6679 46.5131 55.3375V57.5652H38.6369V55.3375C38.6369 54.6679 38.0957 54.1201 37.4344 54.1201C36.773 54.1201 36.2319 54.6679 36.2319 55.3375V57.5652H34.1396V52.5863C34.1396 50.7237 35.6307 49.2142 37.4705 49.2142H47.6795C49.5192 49.2142 51.0103 50.7237 51.0103 52.5863V57.5652H48.918Z",
    fill: "#FD7E14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsentPresentReportIcon);
export default __webpack_public_path__ + "static/media/absent_present_report_icon.0e949eb3ec5cfa7e1090682142a2a639.svg";
export { ForwardRef as ReactComponent };